<template>
  <a-row :gutter="16">
    <a-col :xxl="4" :xl="6" :lg="8" :md="12">
      <a-range-picker v-model:value="queryForm.daterange" :locale="locale" value-format="YYYY-MM-DD"
        style="width:100%;" />
    </a-col>
    <a-col :xxl="3" :xl="4" :lg="8" :md="12">
      <a-select v-model:value="queryForm.orgid" :options="qorgs" :filter-option="$filters.filterOption" show-search
        style="width:100%;">
      </a-select>
    </a-col>
    <a-col :xxl="3" :xl="4" :lg="8" :md="12">
      <a-select v-model:value="queryForm.state" :options="qstates" style="width:100%;">
      </a-select>
    </a-col>
    <a-col :xxl="3" :xl="4" :lg="8" :md="12">
      <a-button type="primary" @click="refresh">查询</a-button>
    </a-col>
  </a-row>
  <div class="static">
    <a-row>
      <a-col :span="6">
        <div v-if="loading" style="height:64px;" class="d-flex flex-column justify-space-between">
          <span class="text-gray">总授信额度(¥)</span>
          <LoadingOutlined style="text-align: left;" />
        </div>
        <a-statistic v-else title="总授信额度(¥)" :precision="2" :value="total_grant" />
      </a-col>
      <a-col :span="6">
        <div v-if="loading" style="height:64px;" class="d-flex flex-column justify-space-between">
          <span class="text-gray">总放款(¥)</span>
          <LoadingOutlined style="text-align: left;" />
        </div>
        <a-statistic v-else title="总放款(¥)" :precision="2" :value="total_loan" />
      </a-col>
      <a-col :span="6">
        <div v-if="loading" style="height:64px;" class="d-flex flex-column justify-space-between">
          <span class="text-gray">已放款(¥)</span>
          <LoadingOutlined style="text-align: left;" />
        </div>
        <a-statistic v-else title="已放款(¥)" :precision="2" :value="finished_loan" />
      </a-col>
      <a-col :span="6">
        <div v-if="loading" style="height:64px;" class="d-flex flex-column justify-space-between">
          <span class="text-gray">待放款(¥)</span>
          <LoadingOutlined style="text-align: left;" />
        </div>
        <a-statistic v-else title="待放款(¥)" :precision="2" :value="pending_loan" />
      </a-col>
    </a-row>
  </div>
  <div class="d-flex justify-space-between align-center mb-2">
    <a-space>
      <a-button type="danger" @click="add">
        <template #icon>
          <PlusOutlined />
        </template>
        新增授信</a-button>
      <a-button type="link" @click="refresh">刷新数据</a-button>
    </a-space>
  </div>
  <a-table bordered size="small" :columns="columns" :data-source="data" :loading="dataLoading"
    :scroll="{ x: width, y: 600 }" :pagination="{
      current: page,
      pageSize: limit,
      total: count,
      showQuickJumper: true,
      showSizeChanger: true,
    }" @change="(pagination) => {
      page = pagination.current;
      limit = pagination.pageSize;
    }">
    <template #bodyCell="{ record, column }">
      <template v-if="column.dataIndex === 'org'">
        {{ getorgname(record.orgid) }}
      </template>
      <template v-if="column.dataIndex === 'grant_date'">
        {{ record.grant_date || '-' }}
      </template>
      <template v-if="column.dataIndex === 'grant_quota'">
        {{ record.grant_quota || '-' }}
      </template>
      <template v-if="column.dataIndex === 'loan_amount'">
        {{ record.loan_amount || '-' }}
      </template>
      <template v-if="column.dataIndex === 'state'">
        <a-tag v-if="record.state === 0" class="tag-warning">审批中</a-tag>
        <a-tag v-if="record.state === 1" class="tag-success">审批通过</a-tag>
        <a-tag v-if="record.state === -1" class="tag-error">审批驳回</a-tag>
        <p v-if="record.state === -1" class="text-error" style="font-size:12px;">
          {{ record.reason }}
        </p>
      </template>
      <template v-if="column.dataIndex === 'operation'">
        <a-space>
          <a-button v-if="record.state === 0 || record.state === -1" type="link" @click="edit(record)">编辑</a-button>
          <a-popconfirm v-if="record.state === 0 || record.state === -1" title="确定要删除?" @confirm="remove(record._id)">
            <a-button type="link" danger>删除</a-button>
          </a-popconfirm>
          <a-button v-if="record.state === 0" type="link" danger @click="showAudit(record)">审核</a-button>
        </a-space>
      </template>
    </template>
  </a-table>
  <a-modal v-model:visible="creditModal" title="新增授信" :maskClosable="!saving" :closable="!saving" @cancel="cancelSave">
    <a-form ref="creditFormRef" name="creditForm" :model="creditForm" :label-col="{ span: 6 }"
      :wrapper-col="{ span: 18 }" autocomplete="off">
      <a-row :gutter="16">
        <a-col :span="24">
          <a-form-item label="授信商户" name="orgid" :rules="[{ required: true, message: '请选择商户' }]">
            <a-select v-model:value="creditForm.orgid" :options="sorgs" :filter-option="$filters.filterOption"
              placeholder="请选择" :disabled="saving" show-search>
            </a-select>
          </a-form-item>
        </a-col>
        <a-col :span="24">
          <a-form-item label="申请日期" name="apply_date" :rules="[{ required: true, message: '请选择申请日期' }]">
            <a-date-picker v-model:value="creditForm.apply_date" :locale="locale" :show-now="true" :show-today="true"
              value-format="YYYY-MM-DD" style="width:100%" :disabled="saving" />
          </a-form-item>
        </a-col>
        <a-col :span="24">
          <a-form-item label="申请额度" name="apply_quota" :rules="[{ required: true, message: '请输入申请额度' }]">
            <a-input v-model:value="creditForm.apply_quota" type="number" suffix="¥" placeholder="申请额度"
              :disabled="saving">
            </a-input>
          </a-form-item>
        </a-col>
        <!-- <a-col :span="24">
          <a-form-item label="还款方式" name="repayment_type" :rules="[{ required: true, message: '请选择还款方式' }]">
            <a-select v-model:value="creditForm.repayment_type" :options="repayment_types" placeholder="请选择"
              :disabled="saving">
            </a-select>
          </a-form-item>
        </a-col> -->
        <!-- <a-col :span="24">
          <a-form-item label="还款期限" name="repayment_date" :rules="[{ required: true, message: '请选择还款期限' }]">
            <a-date-picker v-model:value="creditForm.repayment_date" :locale="locale" :show-now="true"
              :show-today="true" value-format="YYYY-MM-DD" style="width:100%" :disabled="saving" />
          </a-form-item>
        </a-col> -->
      </a-row>
    </a-form>
    <template #footer>
      <div class="d-flex justify-end">
        <a-space>
          <a-button :disabled="saving" @click="cancelSave">取消</a-button>
          <a-button type="primary" :loading="saving" @click="save">提交</a-button>
        </a-space>
      </div>
    </template>
  </a-modal>
  <a-modal v-model:visible="auditModal" title="审核" :maskClosable="!auditing" :closable="!auditing"
    @cancel="cancelAudit">
    <a-form ref="auditFormRef" name="auditForm" :model="auditForm" :label-col="{ span: 8 }" :wrapper-col="{ span: 16 }"
      autocomplete="off">
      <a-row :gutter="16">
        <a-col :span="24">
          <a-form-item label="商户">
            {{ auditForm.org }}
          </a-form-item>
        </a-col>
        <a-col :span="24">
          <a-form-item label="授信编号">
            {{ auditForm.number }}
          </a-form-item>
        </a-col>
        <a-col :span="24">
          <a-form-item label="申请日期">
            {{ auditForm.apply_date }}
          </a-form-item>
        </a-col>
        <a-col :span="24">
          <a-form-item label="申请额度">
            {{ auditForm.apply_quota }}
          </a-form-item>
        </a-col>
        <!-- <a-col :span="12">
          <a-form-item label="还款期限">
            {{ auditForm.repayment_date }}
          </a-form-item>
        </a-col> -->
        <a-col :span="24">
          <a-form-item label="审核结果" name="grant_state">
            <a-radio-group v-model:value="auditForm.grant_state">
              <a-radio :value="1">通过</a-radio>
              <a-radio :value="-1">驳回</a-radio>
            </a-radio-group>
          </a-form-item>
        </a-col>
        <template v-if="auditForm.grant_state === 1">
          <a-col :span="24">
            <a-form-item label="授信额度" name="grant_quota" :rules="[{ required: true, message: '请输入授信额度' }]">
              <a-input v-model:value="auditForm.grant_quota" type="number" placeholder="授信额度" :disabled="auditing">
              </a-input>
            </a-form-item>
          </a-col>
          <a-col :span="24">
            <a-form-item label="授信日期" name="grant_date" :rules="[{ required: true, message: '请选择授信日期' }]">
              <a-date-picker v-model:value="auditForm.grant_date" :locale="locale" :show-now="true" :show-today="true"
                value-format="YYYY-MM-DD" style="width:100%" :disabled="auditing" />
            </a-form-item>
          </a-col>
        </template>
        <a-col :span="24" v-else>
          <a-form-item label="驳回原因" name="reason" :rules="[{ required: true, message: '请输入驳回原因' }]">
            <a-input v-model:value="auditForm.reason" placeholder="原因" :disabled="auditing"></a-input>
          </a-form-item>
        </a-col>
      </a-row>
    </a-form>
    <template #footer>
      <div class="d-flex justify-end">
        <a-space>
          <a-button :disabled="auditing" @click="cancelAudit">取消</a-button>
          <a-button type="primary" :loading="auditing" @click="submitAudit">提交</a-button>
        </a-space>
      </div>
    </template>
  </a-modal>
</template>
<script setup>
import locale from 'ant-design-vue/es/date-picker/locale/zh_CN';
import { PlusOutlined, LoadingOutlined } from "@ant-design/icons-vue";
import { message } from "ant-design-vue";
import { ref, watch, computed, onMounted, getCurrentInstance } from "vue";
import _ from "underscore";
const columns = [
  { title: '编号', dataIndex: 'number', width: 100 },
  { title: '商户名称', dataIndex: 'org', width: 150 },
  { title: '申请日期', dataIndex: 'apply_date', width: 120, },
  { title: '申请额度(¥)', dataIndex: 'apply_quota', width: 120, },
  { title: '授信日期', dataIndex: 'grant_date', width: 120, },
  { title: '授信额度(¥)', dataIndex: 'grant_quota', width: 120, },
  { title: '已放款(¥)', dataIndex: 'loan_amount', width: 100, },
  { title: '产生利息(¥)', dataIndex: 'interest_amount', width: 100, },
  { title: '已还款(¥)', dataIndex: 'repayment_amount', width: 100, },
  { title: '状态', dataIndex: 'state', width: 100, },
  { title: '创建时间', dataIndex: 'create_time', width: 120, },
  { title: '操作', dataIndex: 'operation', width: 150, fixed: "right" }
];
const { proxy } = getCurrentInstance();
const creditFormRef = ref();
const auditFormRef = ref();

const queryForm = ref({
  daterange: ["", ""],
  orgid: "ALL",
  state: "ALL",
});
const states = ref([
  { value: "0", label: "审批中" },
  { value: "1", label: "审批通过" },
  { value: "-1", label: "审批驳回" },
]);
const dataLoading = ref(false);
const loading = ref(false);
const page = ref(1);
const limit = ref(20);
const length = ref(0);
const count = ref(0);
const data = ref([]);
const orgs = ref([]);
const repayment_types = ref([]);
const total_grant = ref(0);
const total_loan = ref(0);
const finished_loan = ref(0);
const pending_loan = ref(0);
const creditForm = ref({});
const creditModal = ref(false);
const saving = ref(false);
const auditForm = ref({});
const auditModal = ref(false);
const auditing = ref(false);

const sorgs = computed(() => orgs.value.map(n => ({ value: n._id, label: n.name })));
const qorgs = computed(() => {
  return [
    { value: 'ALL', label: '全部商户' },
    ...sorgs.value,
  ]
});
const qstates = computed(() => {
  return [
    { value: 'ALL', label: '全部' },
    ...states.value,
  ]
});
const width = computed(() => proxy.$utils.twidth(columns));

watch(() => page.value, () => {
  getData();
});
watch(() => limit.value, () => {
  if (page.value !== 1) page.value = 1;
  else getData();
});

onMounted(() => {
  refresh();
});
const refresh = () => {
  getData();
  getStatistics();
}
const getData = () => {
  dataLoading.value = true;
  proxy.$api.doAPI("/credit/list", { page: page.value, limit: limit.value, ...queryForm.value }).then((res) => {
    dataLoading.value = false;
    if (res.code === 0) {
      data.value = _.map(res.data.list, n => {
        return {
          ...n,
          create_time: proxy.$dateFormat(n.create_time, 'YYYY-MM-DD HH:mm'),
        }
      });
      length.value = res.data.length;
      count.value = res.data.count;
      if (length.value > 0 && page.value > length.value) page.value = 1;
      orgs.value = res.data.orgs;
      repayment_types.value = res.data.repayment_types;
    } else {
      message.error(res.msg);
    }
  }).catch((err) => {
    dataLoading.value = false;
    console.error(err);
  });
};
const getStatistics = () => {
  loading.value = true;
  proxy.$api.doAPI("/credit/statistics", { page: page.value, limit: limit.value, ...queryForm.value }).then((res) => {
    loading.value = false;
    if (res.code === 0) {
      total_grant.value = res.data.total_grant;
      total_loan.value = res.data.total_loan;
      finished_loan.value = res.data.finished_loan;
      pending_loan.value = res.data.pending_loan;
    } else {
      message.error(res.msg);
    }
  }).catch((err) => {
    loading.value = false;
    console.error(err);
  });
};
const initForm = () => {
  return {
    _id: "",
    orgid: null,
    apply_date: proxy.$dateFormat(), apply_quota: '',
    repayment_type: null, repayment_date: null,
  };
};
const add = () => {
  creditForm.value = initForm();
  creditModal.value = true;
};
const edit = (item) => {
  creditForm.value = _.pick(item, _.keys(initForm()));
  creditModal.value = true;
}
const save = async () => {
  try {
    await creditFormRef.value.validateFields();
    saving.value = true;
    proxy.$api.doAPI("/credit/save", { dataForm: creditForm.value }).then((res) => {
      saving.value = false;
      if (res.code === 0) {
        message.success("提交成功");
        creditModal.value = false;
        getData();
      } else {
        message.error(res.msg);
      }
    }).catch((err) => {
      saving.value = false;
      console.error(err);
    });
  } catch (errorInfo) {
    console.log("Failed:", errorInfo);
  }
};
const cancelSave = () => {
  creditFormRef.value.clearValidate();
  creditModal.value = false;
};
const remove = (_id) => {
  dataLoading.value = true;
  proxy.$api.doAPI("/credit/remove", { _id }).then((res) => {
    dataLoading.value = false;
    if (res.code === 0) {
      getData();
    } else {
      message.error(res.msg);
    }
  }).catch((err) => {
    dataLoading.value = false;
    console.error(err);
  });
};
const showAudit = (item) => {
  auditForm.value = {
    _id: item._id,
    org: getorgname(item.orgid),
    ..._.pick(item, ['number', 'apply_date', 'apply_quota']),
    grant_state: 1,
    grant_quota: item.apply_quota,
    grant_date: proxy.$dateFormat(),
    reason: '',
  };
  auditModal.value = true;
}
const submitAudit = async () => {
  try {
    await auditFormRef.value.validateFields();
    auditing.value = true;
    proxy.$api.doAPI("/credit/audit", { dataForm: auditForm.value }).then((res) => {
      auditing.value = false;
      if (res.code === 0) {
        message.success("提交成功");
        auditModal.value = false;
        refresh();
      } else {
        message.error(res.msg);
      }
    }).catch((err) => {
      auditing.value = false;
      console.error(err);
    });
  } catch (errorInfo) {
    console.log("Failed:", errorInfo);
  }
}
const cancelAudit = () => {
  auditFormRef.value.clearValidate();
  auditModal.value = false;
}
const getorgname = (orgid) => {
  return _.findWhere(orgs.value, { _id: orgid })?.name;
}
</script>
<style lang="less" scoped>
:deep(.ant-layout-header) {
  display: flex;
  padding: 0 20px;
}

:deep(.ant-table-thead > tr > th) {
  padding: 8px 8px !important;
}

p {
  margin: 0;
  padding: 0;
}

.static {
  padding: 20px;
  background-color: #f2f2f2;
  margin-bottom: 10px;
}
</style>